"use client"

import { PhoneCall, MailOpen, Navigation } from "lucide-react"

export const ContactInfo = () => {
  return (
    <section className="py-8 sm:py-12 lg:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center border-t-4 border-b-4 border-gray-900 py-4 sm:py-6 mb-8 sm:mb-12 animate-in fade-in duration-700">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">Contact Our Visa Team</h2>
          <div className="text-xs sm:text-sm text-gray-600 uppercase tracking-widest mt-2">We're Here to Help</div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-[shadow,border-color,transform] duration-300 p-6 sm:p-8 border border-gray-200 hover:border-amber-600 transform hover:-translate-y-1 animate-in slide-in-from-bottom-4 duration-500">
            <div className="flex flex-col items-center text-center gap-4">
              <div className="flex-shrink-0 bg-amber-500 p-4 rounded-full shadow-md">
                <PhoneCall className="w-7 h-7 sm:w-8 sm:h-8 text-white" />
              </div>
              <div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">Call Us</h3>
                <p className="text-gray-900 font-semibold text-lg mb-2">+63 2 8123 4567</p>
                <p className="text-sm text-gray-600">Monday - Friday</p>
                <p className="text-sm text-gray-600 font-medium">9:00 AM - 6:00 PM</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-amber-50 to-vanilla-100 rounded-lg shadow-lg hover:shadow-xl transition-[shadow,transform] duration-300 p-6 sm:p-8 border-2 border-amber-600 transform hover:-translate-y-1 animate-in slide-in-from-bottom-4 duration-500" style={{ animationDelay: '100ms' }}>
            <div className="flex flex-col items-center text-center gap-4">
              <div className="flex-shrink-0 bg-gray-900 p-4 rounded-full shadow-md">
                <MailOpen className="w-7 h-7 sm:w-8 sm:h-8 text-amber-500" />
              </div>
              <div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">Email Us</h3>
                <p className="text-gray-900 font-semibold text-lg mb-2">visa@twi.com.ph</p>
                <p className="text-sm text-gray-600">Response within</p>
                <p className="text-sm text-gray-600 font-medium">24 hours</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-[shadow,border-color,transform] duration-300 p-6 sm:p-8 border border-gray-200 hover:border-amber-500 transform hover:-translate-y-1 animate-in slide-in-from-bottom-4 duration-500" style={{ animationDelay: '200ms' }}>
            <div className="flex flex-col items-center text-center gap-4">
              <div className="flex-shrink-0 bg-amber-600 p-4 rounded-full shadow-md">
                <Navigation className="w-7 h-7 sm:w-8 sm:h-8 text-white" />
              </div>
              <div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">Visit Us</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  1007 OMM Citra Bldg<br/>
                  San Miguel Ave, Ortigas Center<br/>
                  Pasig City, Philippines 1600
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-amber-50 via-white to-vanilla-100 rounded-lg shadow-md p-6 sm:p-8 lg:p-10 border-l-4 border-amber-600 animate-in fade-in duration-700" style={{ animationDelay: '300ms' }}>
          <div className="max-w-4xl mx-auto">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 flex items-center gap-3">
              <span className="w-2 h-8 bg-amber-600 rounded"></span>
              Expert Visa Assistance
            </h3>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
              Our experienced visa consultants have helped thousands of travelers successfully obtain their visas. We
              handle all the paperwork and guide you through every step of the process, ensuring a smooth and
              stress-free experience.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed font-medium">
              📞 Contact us today to start your visa application and let our experts make your travel dreams a reality.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
